<script>
    export let world_type = 'Cruel';
</script>
{world_type} World
<style>
</style>
